/**
 * AI 찜해둔 상품 바로입기 딥링크.
 *
 * iOS/Android는 Firebase RemoteConfig key `ai_fitting_rooms_zzim` 에서 받지만
 * RN에는 RemoteConfig 직접 접근 브릿지가 없어 fallback 값을 그대로 하드코딩.
 *
 * - iOS  : RemoteConfigFallback.aiFittingRoomsZzim
 * - Android: AblyRemoteConfig.AI_FITTING_ROOMS_ZZIM (default null — Firebase 필수 운영)
 */
export const AI_FITTING_ROOMS_ZZIM_DEEPLINK =
  'ably://webview?title_bar=false&url=content/fitting-rooms/outfit-try-on/browse?selectedTab=zzim';
